declare namespace $ {

	type $mol_button_major__title_bog_ainews_app_feed_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_ainews_app_feed_2 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_feed['summary_all_click'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_minor__title_bog_ainews_app_feed_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_ainews_app_feed_4 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_feed['summary_all_close_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_paragraph__title_bog_ainews_app_feed_5 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_feed['summary_all_result'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_page__title_bog_ainews_app_feed_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__tools_bog_ainews_app_feed_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_bog_ainews_app_feed_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_pop__showed_bog_ainews_app_feed_9 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_feed['summary_all_showed'] >
		,
		ReturnType< $mol_pop['showed'] >
	>
	type $mol_pop__Anchor_bog_ainews_app_feed_10 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_feed['Summary_all_button'] >
		,
		ReturnType< $mol_pop['Anchor'] >
	>
	type $mol_pop__bubble_content_bog_ainews_app_feed_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pop['bubble_content'] >
	>
	type $mol_search__query_bog_ainews_app_feed_12 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_feed['search_word'] >
		,
		ReturnType< $mol_search['query'] >
	>
	type $mol_view__sub_bog_ainews_app_feed_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_deck__items_bog_ainews_app_feed_14 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_feed['Categories'] >
		,
		ReturnType< $mol_deck['items'] >
	>
	type $mol_paragraph__title_bog_ainews_app_feed_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__dom_name_bog_ainews_app_feed_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['dom_name'] >
	>
	type $mol_link__title_bog_ainews_app_feed_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_ainews_app_feed_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_view__sub_bog_ainews_app_feed_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_bog_ainews_app_feed_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_button_major__title_bog_ainews_app_feed_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_ainews_app_feed_22 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_feed['category_summary_click'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_minor__title_bog_ainews_app_feed_23 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_ainews_app_feed_24 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_feed['category_summary_close_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_paragraph__title_bog_ainews_app_feed_25 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_feed['category_summary_result'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_page__title_bog_ainews_app_feed_26 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__tools_bog_ainews_app_feed_27 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_bog_ainews_app_feed_28 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_pop__showed_bog_ainews_app_feed_29 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_feed['category_summary_showed'] >
		,
		ReturnType< $mol_pop['showed'] >
	>
	type $mol_pop__Anchor_bog_ainews_app_feed_30 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_feed['Category_summary_button'] >
		,
		ReturnType< $mol_pop['Anchor'] >
	>
	type $mol_pop__bubble_content_bog_ainews_app_feed_31 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pop['bubble_content'] >
	>
	type $mol_list__rows_bog_ainews_app_feed_32 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_feed['articles'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $bog_ainews_app_feed_img__src_bog_ainews_app_feed_33 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_feed['article_image_src'] >
		,
		ReturnType< $bog_ainews_app_feed_img['src'] >
	>
	type $bog_ainews_app_feed_img__alt_bog_ainews_app_feed_34 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_feed['article_title'] >
		,
		ReturnType< $bog_ainews_app_feed_img['alt'] >
	>
	type $bog_ainews_app_feed_img__width_bog_ainews_app_feed_35 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_ainews_app_feed_img['width'] >
	>
	type $bog_ainews_app_feed_img__height_bog_ainews_app_feed_36 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_ainews_app_feed_img['height'] >
	>
	type $mol_button_minor__title_bog_ainews_app_feed_37 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_ainews_app_feed_38 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_feed['summary_description_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_paragraph__title_bog_ainews_app_feed_39 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_feed['article_description'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_link__title_bog_ainews_app_feed_40 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__target_bog_ainews_app_feed_41 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_feed['open_in_new_tab'] >
		,
		ReturnType< $mol_link['target'] >
	>
	type $mol_link__uri_toggle_bog_ainews_app_feed_42 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_feed['article_link'] >
		,
		ReturnType< $mol_link['uri_toggle'] >
	>
	type $mol_link__title_bog_ainews_app_feed_43 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__target_bog_ainews_app_feed_44 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_feed['open_in_new_tab'] >
		,
		ReturnType< $mol_link['target'] >
	>
	type $mol_link__uri_toggle_bog_ainews_app_feed_45 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_feed['article_translated_link'] >
		,
		ReturnType< $mol_link['uri_toggle'] >
	>
	type $mol_button_minor__title_bog_ainews_app_feed_46 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_ainews_app_feed_47 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_feed['translate_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_check_icon__Icon_bog_ainews_app_feed_48 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_feed['Base_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_check_icon__checked_bog_ainews_app_feed_49 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_feed['base_checked'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_view__sub_bog_ainews_app_feed_50 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__title_bog_ainews_app_feed_51 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_feed['category_title'] >
		,
		ReturnType< $mol_list['title'] >
	>
	type $mol_list__rows_bog_ainews_app_feed_52 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_expander__expanded_bog_ainews_app_feed_53 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_feed['openned_post'] >
		,
		ReturnType< $mol_expander['expanded'] >
	>
	type $mol_expander__label_bog_ainews_app_feed_54 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['label'] >
	>
	type $mol_expander__content_bog_ainews_app_feed_55 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_expander__Tools_bog_ainews_app_feed_56 = $mol_type_enforce<
		ReturnType< $bog_ainews_app_feed['Spoiler_tools'] >
		,
		ReturnType< $mol_expander['Tools'] >
	>
	export class $bog_ainews_app_feed extends $bog_ainews_app_page {
		summary_all_click( next?: any ): any
		Summary_all_button( ): $mol_button_major
		summary_all_showed( next?: boolean ): boolean
		summary_all_close_click( next?: any ): any
		Summary_all_close( ): $mol_button_minor
		summary_all_result( ): string
		Summary_all_text( ): $mol_paragraph
		Summary_all_content( ): $mol_page
		Summary_all_pop( ): $mol_pop
		search_word( next?: string ): string
		Searcher( ): $mol_search
		Hot_fix( ): $mol_view
		Categories( ): readonly(any)[]
		Tabs( ): $mol_deck
		Welcome_block_p1_paragraph( ): $mol_paragraph
		Welcome_block_p2_paragraph( ): $mol_link
		Welcome_block_p2( ): $mol_view
		Welcome_block( ): $mol_list
		category_title( id: any): string
		category_summary_click( id: any, next?: any ): any
		Category_summary_button( id: any): $mol_button_major
		category_summary_showed( id: any, next?: boolean ): boolean
		category_summary_close_click( id: any, next?: any ): any
		Category_summary_close( id: any): $mol_button_minor
		category_summary_result( id: any): string
		Category_summary_text( id: any): $mol_paragraph
		Category_summary_content( id: any): $mol_page
		Category_summary_pop( id: any): $mol_pop
		articles( id: any): readonly(any)[]
		Items( id: any): $mol_list
		openned_post( id: any, next?: boolean ): boolean
		article_title( id: any): string
		article_image_src( id: any): readonly(any)[]
		Article_thumbnail( id: any): $bog_ainews_app_feed_img
		summary_description_click( id: any, next?: any ): any
		Article_description_summary_button( id: any): $mol_button_minor
		article_description( id: any): string
		Article_description( id: any): $mol_paragraph
		open_in_new_tab( id: any): string
		article_link( id: any): string
		Article_link( id: any): $mol_link
		article_translated_link( id: any): string
		Article_translated_link( id: any): $mol_link
		translate_click( id: any, next?: any ): any
		Article_translate_text( id: any): $mol_button_minor
		Base_icon( id: any): $mol_icon_cards_heart
		base_checked( id: any, next?: boolean ): boolean
		Favorite( id: any): $mol_check_icon
		Spoiler_tools( id: any): $mol_view
		app_filters( ): $bog_ainews_app_filters
		app_settings( ): $bog_ainews_app_settings
		app_source( ): $bog_ainews_app_sources
		app_favorites( ): $bog_ainews_app_favorites
		title( ): string
		Logo( ): $mol_icon_script_text
		tools( ): readonly(any)[]
		body( ): readonly(any)[]
		Category_page( id: any): $mol_list
		Article( id: any): $mol_expander
	}
	
	export class $bog_ainews_app_feed_title extends $mol_paragraph {
		font_size_title( ): string
		style( ): ({ 
			'font-size': ReturnType< $bog_ainews_app_feed_title['font_size_title'] >,
		})  & ReturnType< $mol_paragraph['style'] >
	}
	
}

//# sourceMappingURL=feed.view.tree.d.ts.map